export function getCroppedImages(imagesInfo) {
    if (!imagesInfo) {
        return [];
    }

    return imagesInfo.map(({ alternativeSizes = [], title, description }) => {
        const smallImage = alternativeSizes.find(alt => alt.size === 'Small');

        return alternativeSizes.length > 0
            ? {
                url: smallImage ? smallImage.url : alternativeSizes[0].url,
                cropped: !!smallImage,
                title,
                description: description || '',
            }
            : {
                url: '',
                cropped: false,
                title,
                description: description || '',
            };
    });
}
